<template>
    <span v-if="suppressNav"></span>
    <span v-else-if="currentUser.customer_id">
        <v-navigation-drawer app v-model="drawer" color="grey darken-3" dark disable-resize-watcher>
            <v-list>
                <template v-for="(item, index) in items">
                    <v-list-tile :key="index">
                        <v-list-tile-content>
                            {{item.title}}
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider :key="`divider-${index}`"></v-divider>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar app color="grey darken-4" dark>
            <v-toolbar-side-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-toolbar-side-icon>
            <v-spacer class="hidden-md-and-up"></v-spacer>
            <v-toolbar-title>{{appTitle}}</v-toolbar-title>
            <v-btn text class="hidden-sm-and-down">Menu</v-btn>
            <v-spacer class="hidden-sm-and-down"></v-spacer>
            <v-toolbar-items>
                <h3 v-if="(currentUser.email)" color="white" class="hidden-sm-and-down" style='padding-top:1.3rem;padding-right:1.3rem;'>{{currentUser.email}}</h3>
                <v-btn text class="hidden-sm-and-down" @click="logout">Logout</v-btn>
            </v-toolbar-items>
        </v-toolbar>
    </span>
    <span v-else>
        <v-navigation-drawer app v-model="drawer" color="grey darken-3" dark disable-resize-watcher>
            <v-list>
                <template v-for="(item, index) in items">
                    <v-list-tile :key="index">
                        <v-list-tile-content>
                            {{item.title}}
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider :key="`divider-${index}`"></v-divider>
                </template>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar app color="grey darken-4" dark>
            <v-toolbar-side-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-toolbar-side-icon>
            <v-spacer class="hidden-md-and-up"></v-spacer>
            <v-toolbar-title>{{appTitle}}</v-toolbar-title>
            <v-btn text class="hidden-sm-and-down">Menu</v-btn>
            <v-spacer class="hidden-sm-and-down"></v-spacer>
            <v-btn text class="hidden-sm-and-down" to="/login">SIGN IN</v-btn>
            <v-btn color="orange darken-4" class="hidden-sm-and-down" to="/signup">JOIN</v-btn>
        </v-toolbar>
    </span>
</template>

<script>
import { mapState } from 'vuex';
import appconfig from '../config/shared.js';

export default {
    name: 'AppNavigation',
    data () {
        return {
            appTitle: 'NodePing',
            drawer: false,
            suppressNav: true || window.location.pathname.match(appconfig.suppressNavPaths),
            items: [
                { title: 'Menu' },
                { title: 'Sign In' },
                { title: 'Join' }
            ]
        };
    },
    computed: {
        ...mapState(['currentUser'])
    },
    methods: {
        logout () {
            this.$store.dispatch('logout').then( location.reload() );
        }
    }
};
</script>
